import { DELIVERY_RETURNS_CONTENT_SUCCESS } from '../constants';

const initialState = {
    response: {
        body: null,
        headers: null,
        status: null,
        path: null,
    },
    loading: false,
    error: false,
};

export default function deliveryReturnsContentState(state = initialState, action = {}) {
    switch (action.type) {
        case DELIVERY_RETURNS_CONTENT_SUCCESS:
            return {
                ...state,
                response: {
                    body: action.body,
                    headers: action.headers,
                    status: action.status,
                    path: action.uid,
                },
                loading: false,
                error: false,
            };

        default:
            return state;
    }
}
